import * as React from 'react';

export const getRecordingContainerStyles = (): React.CSSProperties => {
  return {
    marginTop: '110px'
  };
};

export const getWarningMessageBarStyles = (): React.CSSProperties => {
  return {
    position: "absolute",
    bottom: 0
  }
}